import clsx from 'clsx';

export function KoursepediaLogo({ large = false, inverted = false }: { large?: boolean; inverted?: boolean }) {
  return (
    <div className={clsx('flex items-center gap-3', large && 'gap-5')}>
      <div
        className={clsx(
          'grid place-items-center rounded-3xl bg-gradient-to-br from-sky-300 to-blue-700 font-display font-extrabold text-white shadow-soft',
          large ? 'h-24 w-24 text-4xl md:h-32 md:w-32 md:text-5xl' : 'h-11 w-11 text-lg',
        )}
      >
        KP
      </div>
      <div>
        <strong className={clsx('block font-display font-extrabold', inverted ? 'text-white' : 'text-ink', large ? 'text-4xl md:text-5xl' : 'text-lg')}>
          Koursepedia
        </strong>
        <span className={clsx('block font-bold uppercase tracking-[0.18em]', inverted ? 'text-cyan-100' : 'text-brand-700', large ? 'text-xs' : 'text-[10px]')}>
          learn.compare.choose.
        </span>
      </div>
    </div>
  );
}
